<div class="modal-container">
  <button
    id="modalDatosAdicionalesAbogado"
    #modalDatosAdicionalesAbogado
    data-bs-toggle="modal"
    data-bs-target="#modalAlerta3"
    hidden="hidden"
    hidden
  aria-hidden="true"
  tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalAlerta3"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content modal-content-govco">
        <div class="p-2 pt-4"></div>
        <div class="modal-body modal-body-govco">
          <div class="p-2">
            <div *ngIf="primerInicioSesion && !openConfigCuenta; else formAbogado">
              <div class="d-flex flex-row align-items-center">
                <img
                  src="../../../../assets/img/file-alt.svg"
                  alt="logo"
                  class="img-ico-form me-2" />
                <h2 class="mb-0">{{ "registry.crear_usuario" | translate }}</h2>
              </div>
              <div class="alert alert-primary my-1" role="alert">
                <h5 class="text-center">
                  {{"datos-adicionales.ejerce_abogado"| translate}}
                </h5>
              </div>
              <!-- form ejerce como abogado? -->
              <app-form
                [title]="''"
                [sumbitButtonText]="modalText['boton']"
                [fields]="ejerceAbogado"
                [withSubmitButton]="false"
                (changedControl)="onSubmitEjerceAbogado($event)">
              </app-form>
              <div class="text-justify mt-2">
                <p class="my-1">{{ "datos-adicionales.recuerde-activar-perfil" | translate }}</p>
              </div>
              <div *ngIf="flagMostrarFormulario">
                <app-form
                  [title]="''"
                  [sumbitButtonText]="modalText['boton']"
                  [fields]="allFields"
                  (submitAction)="onSubmit($event)"
                  (changeAction)="onSubmitFormulario($event)"
                  (changedControl)="onSubmitAbogado($event)">
                </app-form>
              </div>
              <!-- No ejerce como abogado y es su primer inicio sesion -->
              <div class="col-12 d-flex justify-content-end" *ngIf="!flagMostrarFormulario && primerInicioSesion">
                <button
                  type="submit"
                  class="btn btn-govco outline-btn-govco"
                  [disabled]="formEjerceAbogado.invalid"
                  (click)="abrirModalTipoUsuario()"
                  aria-label="Siguiente">
                  {{ "datos-adicionales.boton" | translate }}
                </button>
              </div>
            </div>
            <ng-template #formAbogado>
              <app-form
                [title]="modalText['datos-adicionales']"
                [sumbitButtonText]="modalText['boton']"
                [fields]="allFields"
                (submitAction)="onSubmit($event)"
                (changeAction)="onSubmitFormulario($event)"
                (changedControl)="onSubmitAbogado($event)">
              </app-form>
            </ng-template>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="openModalTipoUsuario">
  <app-modal-select-tipo-usuario [tiposUsuario]="tiposUsuario"
    (tipoUsuarioEmitter)="obtenerTipoUsuario($event)"></app-modal-select-tipo-usuario>
</div>